<div class="camera-app">
  <div class="camera-content">
    <div class="buttonsTop">
      <button mat-button (click)="close()"><mat-icon>close</mat-icon></button>
      <div *ngIf="recordTime > 0" style="color: red">
        {{ segundosAHorasMinutosSegundos(recordTime) }}
      </div>
    </div>

    <video
      #videoElement
      width="100%"
      style="overflow: hidden"
      height="100%"
      autoplay
      [class.hidden]="preview"
      playsinline
      disablePictureInPicture
      [muted]="true"
    ></video>
    <div
      *ngIf="preview && mode !== 'video'"
      style="
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 80vh;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      "
    >
      <img [src]="capturedPhoto" class="captured-photo" alt="Captured Photo" />
    </div>
    <video
      #previewVideo
      width="100%"
      style="overflow: hidden"
      height="100%"
      [src]="capturedPhoto"
      *ngIf="preview && mode === 'video' && !isRecording"
      controls
    ></video>
    <div
      class="slider-buttons-container"
      *ngIf="capturedPhoto && multipleSelectionEnabled"
    >
      <button
        mat-icon-button
        (click)="showPrev()"
        aria-label="Anterior"
        style="font-size: 2rem"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        (click)="removeFile(sliderIndex)"
        aria-label="Eliminar miniatura"
        style="font-size: 2rem; margin: 0 16px; background: white"
      >
        <mat-icon>close</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="showNext()"
        aria-label="Siguiente"
        style="font-size: 2rem"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <div class="toggleFotoVideo" *ngIf="!capturedPhoto">
      <button
        class="buttonToggle"
        (click)="toggleMode()"
        [disabled]="mode === 'photo'"
        [style]="mode === 'photo' ? 'color: yellow' : ''"
      >
        Foto
      </button>
      <button
        *ngIf="!dialogData.onlyPhoto"
        class="buttonToggle"
        (click)="toggleMode()"
        [disabled]="mode === 'video'"
        [style]="mode === 'video' ? 'color: yellow' : ''"
      >
        Video
      </button>
    </div>
    <div class="buttonFoto" *ngIf="!capturedPhoto">
      <div class="fileTracker" *ngIf="!capturedPhoto && !isRecording">
        <mat-icon (click)="fileInput.click()">upload</mat-icon>
        <input
          #fileInput
          type="file"
          accept="image/*, video/*"
          (change)="onFileSelected($event)"
          [multiple]="multipleSelectionEnabled"
          style="display: none"
        />
      </div>
      <button
        *ngIf="!capturedPhoto && !isRecording"
        class="buttonPhotoCambiarCamara"
        (click)="switchCamera()"
      >
        <img
          style="width: 30px; height: 30px"
          src="../../../assets/bergara/flip.png"
        />
      </button>
      <button
        class="buttonPhoto"
        (click)="
          mode !== 'video'
            ? capturePhoto()
            : !isRecording
            ? startRecording()
            : stopRecording()
        "
      >
        <div class="buttonPhotoCenter">
          <div
            *ngIf="mode === 'video'"
            [style]="
              isRecording
                ? 'width: 30px;height: 30px; background-color: red;'
                : 'width: 100%;height: 100%; background-color: red; border-radius: 100%;'
            "
          ></div>
        </div>
      </button>
    </div>
    <div class="mat-dialog-actions" *ngIf="capturedPhoto">
      <button mat-button (click)="repeatPhoto()">Repetir</button>
      <button mat-button (click)="finalizar()">Finalizar</button>
    </div>
    <!-- Previsualización de todos los archivos seleccionados (miniaturas con botón eliminar) -->
    <div
      *ngIf="selectedFiles.length > 0"
      class="multi-preview"
      style="
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: center;
        margin: 16px 0;
      "
    >
      <ng-container *ngFor="let file of selectedFiles; let i = index">
        <div style="position: relative; display: inline-block">
          <img
            *ngIf="file.type === 'photo'"
            [src]="file.base64"
            class="captured-photo"
            alt="Preview"
            style="
              max-width: 100px;
              max-height: 100px;
              border-radius: 8px;
              box-shadow: 0 2px 8px #0002;
              cursor: pointer;
            "
            (click)="sliderIndex = i; updateSliderView()"
          />
          <video
            *ngIf="file.type === 'video'"
            [src]="file.base64"
            controls
            style="
              max-width: 100px;
              max-height: 100px;
              border-radius: 8px;
              box-shadow: 0 2px 8px #0002;
              cursor: pointer;
            "
            (click)="sliderIndex = i; updateSliderView()"
          ></video>
        </div>
      </ng-container>
    </div>
  </div>
</div>
